module.exports = __webpack_public_path__ + "img/logo_lcreditmax.dc233aaa.png";